import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKeyParam } from '../../query/types';

const inventoryKeys = (scopeId: QueryKeyParam, itemId: QueryKeyParam) =>
  createQueryKey({
    all: ['store', scopeId, 'items', itemId, 'inventories'] as const,
    id: (inventoryId: QueryKeyParam) =>
      createQueryKey({
        all: ['store', scopeId, 'items', itemId, 'inventories', inventoryId] as const,
        detail: ['store', scopeId, 'items', itemId, 'inventories', inventoryId, 'detail'] as const,
        adjustments: [
          'store',
          scopeId,
          'items',
          itemId,
          'inventories',
          inventoryId,
          'adjustments',
        ] as const,
        adjustmentsExport: [
          'store',
          scopeId,
          'items',
          itemId,
          'inventories',
          inventoryId,
          'adjustments',
          'export',
        ] as const,
      }),
    export: ['store', scopeId, 'items', itemId, 'inventories', 'export'] as const,
  });

export { inventoryKeys };
